import { numberToHex } from '../../utils/encoding/toHex.js';
export async function setBalance(client, { address, value }) {
    if (client.mode === 'ganache')
        await client.request({
            method: 'evm_setAccountBalance',
            params: [address, numberToHex(value)],
        });
    else
        await client.request({
            method: `${client.mode}_setBalance`,
            params: [address, numberToHex(value)],
        });
}
//# sourceMappingURL=setBalance.js.map